import React from 'react';

const Info = () => {
    return(
        <div className='about_info grid'>
            <div className='about_box'>
                
            <svg xmlns="http://www.w3.org/2000/svg" width="em" height="1em" viewBox="1 1 24 24"><path fill="" d="M5 8.999c0 1.902.765 3.627 2 4.89V21a.998.998 0 0 0 1.447.895L12 20.118l3.553 1.776a.992.992 0 0 0 .972-.043c.295-.183.475-.504.475-.851v-7.11a6.976 6.976 0 0 0 2-4.891C19 5.14 15.86 2 12 2S5 5.14 5 8.999m7.447 9.106a1 1 0 0 0-.895 0L9 19.382v-4.067c.911.434 1.926.685 3 .685s2.089-.25 3-.685v4.066zM12 4c2.756 0 5 2.242 5 4.999A5.006 5.006 0 0 1 12 14c-2.757 0-5-2.243-5-5.001A5.005 5.005 0 0 1 12 4"/></svg>
               
                <h3 className='about_title'>Experience</h3>
                <span className='about_subtitle'>1+ years</span>
            </div>

            <div className='about_box'>

            <svg xmlns="http://www.w3.org/2000/svg" width="em" height="1em" viewBox="1 1 24 24"><path fill="" d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10s10-4.486 10-10S17.514 2 12 2m0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8s8 3.589 8 8s-3.589 8-8 8"/><path fill="currentColor" d="M13 7h-2v6h6v-2h-4z"/></svg>

                <h3 className='about_title'>Graduation Year</h3>
                <span className='about_subtitle'>2024</span>
            </div>

            <div className='about_box'>

            <svg xmlns="http://www.w3.org/2000/svg" width="em" height="1em" viewBox="1 1 24 24"><g fill="" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" color="currentColor"><path d="m5 16l5-3m4-2l5-3m-7-3v5m0 4v5M5 8l5 3m4 2l5 3m1.5-7v5.5m-7 6l5.5-3m-14.5 0l6 3m-7-5.5V9m1-2.5l6-3m9 3l-6-3"/><circle cx="12" cy="3.5" r="1.5"/><circle cx="12" cy="20.5" r="1.5"/><circle cx="3.5" cy="7.5" r="1.5"/><circle cx="20.5" cy="7.5" r="1.5"/><circle cx="20.5" cy="16.5" r="1.5"/><circle cx="3.5" cy="16.5" r="1.5"/><path d="m12 9.75l2 1.125v2.25l-2 1.125l-2-1.125v-2.25z"/></g></svg>

                <h3 className='about_title'>Current Technologies</h3>
                <span className='about_subtitle'>Java, NodeJs, SQL </span>
            </div>
        </div>
    )
}

export default Info;
